(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredient-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var desktopHover = window.matchMedia('(hover: hover) and (pointer: fine)');

    document.querySelectorAll('[id^="ing--"]').forEach(function (section) {
      section.querySelectorAll('.ing_hov_box').forEach(function (label) {
        var radio = document.getElementById(label.getAttribute('for'));
        if (!radio) return;

        // Desktop: hovering a box "selects" it — and it stays selected
        label.addEventListener('mouseenter', function () {
          if (desktopHover.matches) radio.checked = true;
        });
        // Mobile: tapping the label checks the radio natively — nothing to do
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline-tabs-section"] && !Shopify.designMode) return;
  try {
    
// (() => {
//   const sections = document.querySelectorAll('.timeline');

//   sections.forEach((section) => {
//     const tabs = [...section.querySelectorAll('[role="tab"]')];
//     const panels = [...section.querySelectorAll('[data-timeline-panel]')];

//     if (!tabs.length || !panels.length) return;

//     const closePanel = (panel) => {
//       panel.inert = true;
//       panel.setAttribute('aria-hidden', 'true');

//       if (panel.style.height === 'auto' || !panel.style.height) {
//         panel.style.height = `${panel.scrollHeight}px`;
//       }

//       requestAnimationFrame(() => {
//         panel.classList.remove('is-active');
//         panel.style.height = '0px';
//       });
//     };

//     const openPanel = (panel) => {
//       panel.inert = false;
//       panel.setAttribute('aria-hidden', 'false');
//       panel.classList.add('is-active');
//       panel.style.visibility = 'visible';
//       panel.style.height = '0px';

//       requestAnimationFrame(() => {
//         panel.style.height = `${panel.scrollHeight}px`;
//       });

//       panel.addEventListener(
//         'transitionend',
//         () => {
//           if (panel.classList.contains('is-active')) {
//             panel.style.height = 'auto';
//           }
//         },
//         { once: true }
//       );
//     };

//     const activate = (index, allowClose = false) => {
//       const selectedTab = tabs[index];
//       const selectedPanelId = selectedTab.getAttribute('aria-controls');
//       const selectedPanel = section.querySelector(`#${selectedPanelId}`);

//       if (!selectedPanel) return;

//       const alreadyActive = selectedTab.classList.contains('is-active');

//       if (alreadyActive && allowClose) {
//         selectedTab.classList.remove('is-active');
//         selectedTab.setAttribute('aria-selected', 'false');
//         selectedTab.setAttribute('tabindex', '-1');

//         closePanel(selectedPanel);
//         return;
//       }

//       tabs.forEach((tab) => {
//         const isSelected = tab === selectedTab;

//         tab.classList.toggle('is-active', isSelected);
//         tab.setAttribute(
//           'aria-selected',
//           isSelected ? 'true' : 'false'
//         );
//         tab.setAttribute(
//           'tabindex',
//           isSelected ? '0' : '-1'
//         );
//       });

//       panels.forEach((panel) => {
//         if (panel === selectedPanel) {
//           openPanel(panel);
//         } else {
//           closePanel(panel);
//         }
//       });
//     };

//     tabs.forEach((tab, index) => {
//       tab.addEventListener('click', () => {
//         const isMobile =
//           window.matchMedia('(max-width: 749px)').matches;

//         activate(index, isMobile);
//       });

//       tab.addEventListener('keydown', (event) => {
//         let nextIndex = index;

//         if (
//           event.key === 'ArrowRight' ||
//           event.key === 'ArrowDown'
//         ) {
//           nextIndex = (index + 1) % tabs.length;
//         } else if (
//           event.key === 'ArrowLeft' ||
//           event.key === 'ArrowUp'
//         ) {
//           nextIndex =
//             (index - 1 + tabs.length) % tabs.length;
//         } else if (event.key === 'Home') {
//           nextIndex = 0;
//         } else if (event.key === 'End') {
//           nextIndex = tabs.length - 1;
//         } else {
//           return;
//         }

//         event.preventDefault();

//         tabs[nextIndex].focus();
//         activate(nextIndex);
//       });
//     });

//     const firstPanel = panels.find((panel) =>
//       panel.classList.contains('is-active')
//     );

//     panels.forEach((panel) => {
//       panel.style.height =
//         panel === firstPanel ? 'auto' : '0px';
//     });
//   });
// })();
(() => {
  const sections = document.querySelectorAll('.timeline');

  sections.forEach((section) => {
    // Guard: never double-init the same section
    if (section.dataset.timelineInit === 'true') return;
    section.dataset.timelineInit = 'true';

    const tabs = [...section.querySelectorAll('[role="tab"]')];
    const panels = [...section.querySelectorAll('[data-timeline-panel]')];

    if (!tabs.length || !panels.length) return;

    const closePanel = (panel) => {
      // Cancel any pending animation frame from a previous open/close
      if (panel._timelineRaf) {
        cancelAnimationFrame(panel._timelineRaf);
        panel._timelineRaf = null;
      }

      panel.inert = true;
      panel.setAttribute('aria-hidden', 'true');

      if (panel.style.height === 'auto' || !panel.style.height) {
        panel.style.height = `${panel.scrollHeight}px`;
      }

      panel._timelineRaf = requestAnimationFrame(() => {
        panel._timelineRaf = null;
        panel.classList.remove('is-active');
        panel.style.height = '0px';
      });
    };

    const openPanel = (panel) => {
      panel.inert = false;
      panel.setAttribute('aria-hidden', 'false');
      panel.style.visibility = 'visible';

      // ✅ Already open → do nothing.
      // This is what fixes the double-click "content hides" glitch —
      // we never reset height on an open panel.
      if (panel.classList.contains('is-active')) return;

      if (panel._timelineRaf) {
        cancelAnimationFrame(panel._timelineRaf);
        panel._timelineRaf = null;
      }

      panel.classList.add('is-active');
      panel.style.height = '0px';

      panel._timelineRaf = requestAnimationFrame(() => {
        panel._timelineRaf = null;
        panel.style.height = `${panel.scrollHeight}px`;
      });

      const onOpenEnd = (event) => {
        // Only react to the height transition — opacity finishes
        // earlier and was stealing the {once} listener before
        if (event.propertyName !== 'height') return;
        panel.removeEventListener('transitionend', onOpenEnd);
        if (panel.classList.contains('is-active')) {
          panel.style.height = 'auto';
        }
      };
      panel.addEventListener('transitionend', onOpenEnd);
    };

    const activate = (index) => {
      const selectedTab = tabs[index];
      const selectedPanelId = selectedTab.getAttribute('aria-controls');
      const selectedPanel = section.querySelector(`#${selectedPanelId}`);

      if (!selectedPanel) return;

      // ✅ Tabs are NOT a toggle anymore:
      // clicking the already-active tab is a no-op —
      // the panel can never be closed by clicking.
      if (selectedTab.classList.contains('is-active')) return;

      tabs.forEach((tab) => {
        const isSelected = tab === selectedTab;

        tab.classList.toggle('is-active', isSelected);
        tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        tab.setAttribute('tabindex', isSelected ? '0' : '-1');
      });

      panels.forEach((panel) => {
        if (panel === selectedPanel) {
          openPanel(panel);
        } else {
          closePanel(panel);
        }
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        // Same behavior on mobile & desktop — always opens, never toggles
        activate(index);
      });

      tab.addEventListener('keydown', (event) => {
        let nextIndex = index;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = (index + 1) % tabs.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = (index - 1 + tabs.length) % tabs.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = tabs.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        tabs[nextIndex].focus();
        activate(nextIndex);
      });
    });

    const firstPanel = panels.find((panel) =>
      panel.classList.contains('is-active')
    );

    panels.forEach((panel) => {
      panel.style.height = panel === firstPanel ? 'auto' : '0px';
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
